// LandingSchema.js
const LandingSchema = ({ post, serviceData, canonicalLocale }) => {
  const baseUrl = "https://bgrem.ai";
  const languagePath = canonicalLocale !== "en" ? `/${canonicalLocale}` : "";
  const fullUrl = `${baseUrl}${languagePath}/landings/${post.SEO.Linck_name}`;

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": fullUrl,
    "url": fullUrl,
    "name": post.SEO.Title,
    "description": post.SEO.Description,
    "inLanguage": canonicalLocale,
    "isPartOf": { "@type": "WebSite", "@id": baseUrl, "name": "BgRem.ai", "url": baseUrl },
    "primaryImageOfPage": { "@type": "ImageObject", "url": post.Top?.Main_image?.data?.attributes?.url },
  };

  return (<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />);
};

export default LandingSchema;
